import { API } from "@/api/client"
import { appPath } from "@/shared/lib/appPath"
import { toast } from "@/components/ui/toast"
import { demoQuotaMessage, isDemoQuotaError } from "@/shared/lib/demoQuota"

export const api = new API({ withCredentials: true })

api.instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const url = String(error?.config?.url ?? "")
        if (isDemoQuotaError(error)) {
            toast.error(demoQuotaMessage(error?.response?.data?.scope), { id: "demo-quota" })
        }
        if (status === 401 && !url.includes("/auth/me")) {
            api.instance.get("/auth/me").catch(() => {
                const target = appPath("/login")
                if (window.location.pathname !== target) {
                    window.location.assign(target)
                }
            })
        }
        return Promise.reject(error)
    },
)
